<template>
  <Teleport v-if="$route.query.hideIntroPopUp" defer to="#portal_popup">
    <modal-window
      :is-form="false"
      :modal_open="true"
      :max-width="1250"
      title="Introduction"
      @close="$router.push({ query: { ...$route.query, hideIntroPopUp: undefined } }).catch(() => {})"
    >
      <div class="md:flex gap-10 max-w-4xl mx-auto">
        <div class="lg:flex-1 bg-gray-200 rounded-lg flex flex-col text-center p-5" v-if="false">
          <div class="mb-5">
            <strong class="text-2xl">Welcome to {{ companyName }} Quotes & Orders</strong>
          </div>
          <div class="mb-5">
            <span>Here's a few videos to get you started.</span>
          </div>
          <div class="mb-5 px-10">
            <div class="relative rounded-full overflow-hidden inline-block">
              <img src="@/assets/images/knowledgebase.png" />
            </div>
          </div>
          <div class="mb-5">
            <span>Visit our Knowledge Base for a whole host of videos explaining every feature of QUOTILA Portal.</span>
          </div>
          <div class="mb-5 mt-auto">
            <a
              class="flex rounded-lg bg-gradient-to-r from-orange-400 via-pink-500 to-red-500 py-3 px-5 items-center text-white cursor-pointer max-w-lg mx-auto"
              href="https://bmgroupholdingslimited.freshdesk.com/support/solutions/101000252285"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div class="mr-5 bg-blue-400 rounded-lg p-1 border-solid border-2 border-white w-8 h-8 box-content">
                <i class="text-md fa fa-video-camera" :style="{ 'line-height': '2rem' }" />
              </div>
              <div class="text-left">
                <div>
                  <span class="text-lg">Visit Knowledge Base</span>
                </div>
                <div>
                  <span class="text-sm">Free Help & Support</span>
                </div>
              </div>
              <div class="ml-auto">
                <i class="text-lg fa fa-chevron-right" />
              </div>
            </a>
          </div>
        </div>
        <div class="mt-5 md:mt-0" :style="{ flex: '2 1' }">
          <div class="mb-5 text-center">
            <strong class="text-2xl">Explore the Knowledge Base</strong>
          </div>
          <div
            class="grid xs:grid-cols-2 md:grid-cols-none lg:grid-cols-2 gap-5 mx-auto"
            :style="{ 'grid-auto-rows': '1fr' }"
          >
            <a
              v-for="item in knowledgeBaseStore.filteredArticles"
              :key="item.id"
              :href="`${config.store_url}item.url`"
              target="_blank"
              rel="noopener noreferrer"
              class="bg-gray-200 rounded-lg p-5 flex"
            >
              <div class="relative flex-1">
                <img
                  :src="knowledgebaseImages[`/src/assets/images/knowledge-base/${item.imageURL}`]"
                  class="w-100 rounded-lg"
                />
              </div>
              <div class="flex-1 pl-5">
                <div v-if="item.duration">
                  <span class="text-xs">{{ item.duration }}</span>
                </div>
                <div class="mb-3">
                  <span class="text-lg">{{
                    $t(`dashboard.knowledgeBase.articles.${item.id}.title`, ['Portal', 'Branded Mode', 'Web2Print'])
                  }}</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="w-64 mt-5">
        <label class="flex items-center">
          <input v-model="hideIntroPopUp" type="checkbox" />
          <span class="ml-2 p-1">Don't show again</span>
        </label>
      </div>
    </modal-window>
  </Teleport>
</template>

<script>
import { useBrandedStore } from '@/pinia/branded'
import { useKnowledgeBaseStore } from '@/pinia/knowledge-base'
import { useStyleStore } from '@/pinia/style'
import { config } from '@/utils/config'
import { mapStores } from 'pinia'

export default {
  props: {
    companyName: String
  },
  data() {
    return {
      hideIntroPopUp: false,
      knowledgebaseImages: import.meta.glob('@/assets/images/knowledge-base/*.{png,jpg,jpeg,gif}', {
        eager: true,
        import: 'default'
      })
    }
  },
  computed: {
    ...mapStores(useBrandedStore, useStyleStore, useKnowledgeBaseStore)
  },
  setup() {
    return { config }
  },
  watch: {
    hideIntroPopUp() {
      this.brandedStore.setHideIntroPopUp(this.hideIntroPopUp)
    }
  },
  mounted() {
    this.hideIntroPopUp = this.brandedStore.hideIntroPopUp
    if (!this.hideIntroPopUp) {
      this.checkIsBefore30Days()
    }
  },
  methods: {
    checkIsBefore30Days() {
      const dateSinceStoreCleared = new Date(this.brandedStore.dateSinceStoreCleared)
      const ThirtyDaysTime = new Date().getTime() + 30 * 24 * 60 * 60 * 1000
      if (dateSinceStoreCleared < ThirtyDaysTime) {
        setTimeout(() => {
          this.$router.push({ query: { ...this.$route.query, hideIntroPopUp: true } }).catch(() => {})
        }, 3000)
      }
    }
  }
}
</script>
